import type { DetailedHTMLProps, FC, HTMLAttributes } from 'react'
import { useEffect, useState } from 'react'

import cn from 'classnames'

import styles from '@web/shared/components/spinner/ui/spinner.module.css'

type TProps = {
  delay?: number
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>

export const Spinner: FC<TProps> = ({ delay = 300, className, ...props }) => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), delay)
    return () => clearTimeout(timer)
  }, [delay])

  return (
    visible && (
      <div {...props} className={cn(styles.container, className)}>
        <div className={styles.spinner} />
      </div>
    )
  )
}
